require("./css/style.less")
require("./js/jquery.token-input")
require("./js/hu")



//////////////////
// WEBPACK FOOTER
// ./vendor/vi-kon/laravel-admin/src/resources/assets/js-tokeninput/index.js
// module id = 324
// module chunks = 0